import React from "react";
import { Link, useParams } from "react-router-dom";
import MusicShell from "../fanHome/MusicShell";
import { ACCENT } from "../artistStudio/shared";
import { CMS_SLUGS, CmsHtml, useCmsPage } from "../legal/cmsContent";
import { POLICIES } from "./RightsHub";

// /rights/policies/:slug (mobile design, screen 44): a policy opened from the Rights & legal hub. The text is the CMS page the admin
// edits. Terms and Privacy use the pages that already exist; the DMCA / Copyright Policy and Community Guidelines pages are read from
// the CMS slugs below and show "not available yet" until the admin creates them.
export const POLICY_SLUGS = {
  terms: CMS_SLUGS.TERMS,
  privacy: CMS_SLUGS.PRIVACY_POLICY,
  dmca: "dmca-copyright-policy",
  "community-guidelines": "community-guidelines",
};

export default function PolicyViewer() {
  const { slug } = useParams();
  const known = POLICIES.find((p) => p.slug === slug);
  const { status, page, reload } = useCmsPage(POLICY_SLUGS[slug] || "", Boolean(known));
  return (
    <MusicShell maxWidth="max-w-3xl">
      <Link to="/rights" className="text-sm font-semibold hover:underline" style={{ color: ACCENT }}>← Rights &amp; legal</Link>
      {!known ? (
        <p className="mt-6 text-gray-700" role="alert">This policy could not be found.</p>
      ) : (
        <>
          <h1 className="mt-3 text-2xl md:text-3xl font-bold text-gray-900">{known.title}</h1>
          {(status === "idle" || status === "loading") && <p role="status" className="mt-6 text-gray-600">Loading…</p>}
          {status === "error" && (
            <div role="alert" className="mt-6 rounded-2xl border border-gray-200 bg-gray-50 p-5 text-gray-700">
              <p>This page is not available yet, or we couldn't load it right now.</p>
              <button type="button" onClick={reload} className="mt-3 rounded-full border border-gray-300 px-4 py-1.5 text-sm font-semibold hover:bg-white">Try again</button>
            </div>
          )}
          {status === "ready" && <CmsHtml html={page.content} className="mt-6" data-testid="policy-body" />}
        </>
      )}
    </MusicShell>
  );
}
